// import MockedHsGradPageContentData from './hs-grad-page-content-data.json'
// import MockedHsGradServiceData from './hs-grad-service-data.json'
// import MockedAffiliationData from './affiliation-data.json'

const pageContentData = window.pageContentData || window.hsGradPageContentData
const packageBrowsedata = window.packageBrowseData || window.hsGradServiceData
const affiliationData = window.affiliationData

export const AppData = {
    packageBrowseData: packageBrowsedata ?? {},
    pageContentData: pageContentData ?? [],
    affiliationData: affiliationData ?? {}
}

//! Mocked Data Only For Local Usage
// export const AppData = {
//     packageBrowseData: MockedHsGradServiceData,
//     pageContentData: MockedHsGradPageContentData,
//     affiliationData: MockedAffiliationData
// }